import { Input, Select, Space } from "antd";
import useSearch from "../../../helpers/hooks/useSearch";
import {
  availableDroneModelsAtom,
  availableStatusesListAtom,
  availableTemplatesAtom,
  currentDronesListPageAtom,
  selectedDroneModelsAtom,
  selectedStatusesAtom,
  selectedTemplatesAtom
} from "../state";
import { useAtom } from "jotai";
import { useTranslation } from "../../../hooks/useTranslation";

function DronesPageToolbar() {
  const { t } = useTranslation();
  const { searchText, handleSearch } = useSearch('');
  const [currentPage, setPage] = useAtom(currentDronesListPageAtom);
  const [statuses, setStatuses] = useAtom(selectedStatusesAtom);
  const [dronesModels, setDronesModels] = useAtom(selectedDroneModelsAtom);
  const [templates, setTemplates] = useAtom(selectedTemplatesAtom);
  const [availableDroneModels, setAvailableDroneModels] = useAtom(availableDroneModelsAtom);
  const [availableTemplates] = useAtom(availableTemplatesAtom);
  const [availableStatusesList, setAvailableStatusesListAtom] = useAtom(availableStatusesListAtom);

  return (
    <Space style={{width: '100%', marginBottom: '1rem'}}>
      <Input.Search
        placeholder={t('common:search')}
        defaultValue={searchText}
        onChange={(e) => handleSearch(e, () => setPage(0))}
      />
      <Select
        mode="tags"
        value={statuses}
        placeholder={t('common:status')}
        style={{ width: '100%', minWidth: '200px' }}
        onChange={(keys) => setStatuses(keys)}
        options={[
          // { label: "All", value: "all" },
          ...(availableStatusesList || []),
        ]}
      />
      <Select
        mode="tags"
        value={dronesModels}
        placeholder={t('common:droneModels')}
        style={{ width: '100%', minWidth: '200px' }}
        onChange={(keys) => setDronesModels(keys)}
        options={[
          // { label: "All", value: "all" },
          ...(availableDroneModels || []).map((model) => ({ label: model, value: model }))
        ]}
      />
      <Select
        mode="tags"
        value={templates}
        placeholder={t('templates:filterByTemplate')}
        style={{ width: '100%', minWidth: '200px' }}
        onChange={(keys) => setTemplates(keys)}
        options={[
          { label: t('templates:withoutTemplate'), value: 'null' },
          ...(availableTemplates || [])
        ]}
      />
    </Space>
  )
}

export default DronesPageToolbar;
